/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListSpedResponseDto } from '../../models/list-sped-response-dto';

export interface GlsControllerGetShipmentList$Params {
}

export function glsControllerGetShipmentList(http: HttpClient, rootUrl: string, params?: GlsControllerGetShipmentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ListSpedResponseDto>> {
  const rb = new RequestBuilder(rootUrl, glsControllerGetShipmentList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListSpedResponseDto>;
    })
  );
}

glsControllerGetShipmentList.PATH = '/couriers/gls/list-sped';
